import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

const AppkitIcon = ({ className, icon, type, size, ...rest }) => (
  <i
    className={classnames(className, `icon-${icon}-${type}`, `icon-size-${size}`)}
    {...rest}
  />
);

AppkitIcon.defaultProps = {
  className: '',
  type: 'outline',
};

AppkitIcon.propTypes = {
  className: PropTypes.string,
  icon: PropTypes.string.isRequired,
  type: PropTypes.oneOf([
    'outline',
    'fill',
    'full',
  ]),
  size: PropTypes.number.isRequired,
};

export default AppkitIcon;
